import React from 'react';
import { useForm } from 'react-hook-form';
import Form from '@/shared/ui/Form/Form';
import StringInput, { TextInput } from '@/shared/ui/Inputs/StringInput';
import SelectInput from '@/shared/ui/Inputs/SelectInput';
import Button from '@/shared/ui/Buttons/Button';
import { FlexColumn } from '@/shared/ui/Layouts/Flex';
import { TestCaseGroupCreateDTO } from '@/shared/api/gen/data-contracts';

interface Props {
    projectRef: number;
    onSubmit: (data: TestCaseGroupCreateDTO) => Promise<void>;
    onCancel: () => void;
}

export function TestCaseGroupForm({ projectRef, onSubmit, onCancel }: Props) {
    const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<TestCaseGroupCreateDTO>({
        defaultValues: { priority: 3, project_ref: projectRef },
    });

    return (
        <FlexColumn style={{ alignItems: 'flex-start' }}>
            <h2 className='text-24'>Новая группа</h2>
            <Form
                onSubmit={handleSubmit(onSubmit)}
                style={{ height: '100%', width: '100%', overflow: 'hidden' }}
            >
                <StringInput
                    label="Название группы*"
                    register={register('title', { required: 'обязательное поле' })}
                    error={errors.title?.message}
                />
                <TextInput
                    label="Описание"
                    register={register('description')}
                />
                <SelectInput
                    label="Приоритет"
                    register={register('priority')}
                    choices={[
                        { value: 1, title: '1 — Минимальный' },
                        { value: 2, title: '2 — Низкий' },
                        { value: 3, title: '3 — Средний' },
                        { value: 4, title: '4 — Высокий' },
                        { value: 5, title: '5 — Критический' },
                    ]}
                />
                <div className='FormRow'>
                    <Button type='submit' disabled={isSubmitting}>Создать</Button>
                    <Button type='button' onClick={onCancel}>Отмена</Button>
                </div>
            </Form>
        </FlexColumn>
    );
}
